import styledC from 'styled-components';
import MenuItem from '../../layout/Menu/MenuItem';
const VirtualizedMenuItem = styledC(MenuItem).attrs(props => ({
  style: {
    transform: "translateY(".concat(props.start, "px)"),
    height: "".concat(props.height, "px")
  }
})).withConfig({
  displayName: "VirtualizedMenuItem",
  componentId: "sc-1ill1h4-0"
})(["position:absolute;top:0px;left:0px;width:100%;"]);
VirtualizedMenuItem.displayName = 'VirtualizedMenuItem';
export default VirtualizedMenuItem;
//# sourceMappingURL=VirtualizedMenuItem.js.map